import { render, staticRenderFns } from "./OrganizationMdtRoomDetail.vue?vue&type=template&id=10c440ba&scoped=true"
import script from "./OrganizationMdtRoomDetail.vue?vue&type=script&lang=js"
export * from "./OrganizationMdtRoomDetail.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMdtRoomDetail.vue?vue&type=style&index=0&id=10c440ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c440ba",
  null
  
)

export default component.exports